import { Title } from '@shared/components/title/models';
import { ElasticSearchResponse, Popin, PopinDocument } from '@shared/services/elastic-search/models';
import { LogsService } from '@shared/services/logs';
import { getStableId } from '@shared/utils';

function parseTitle(json?: string): Title | undefined {
  if (!json) return undefined;
  try {
    const parsed = JSON.parse(json) as Partial<Title>;
    return parsed && typeof parsed.text === 'string' && parsed.text.length > 0 && parsed.as
      ? (parsed as Title)
      : undefined;
  } catch (err) {
    LogsService.warn('popinsSerializer', `Failed to parse popin title JSON: ${json}`, err, { gcp: true });
    return undefined;
  }
}

export const popinsSerializer = (response: ElasticSearchResponse<PopinDocument>): Popin[] =>
  response.hits.hits.map((hit) => {
    const source = hit._source;
    const id = getStableId(hit._id);
    const parsedTitle = parseTitle(source.title?.[0]);
    return {
      title: parsedTitle,
      text: source.text?.[0] ?? undefined,
      urls: source.urls,
      id,
    };
  });
